
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.582 21.67A2.337 2.337 0 017.252 24a2.337 2.337 0 01-2.33-2.33 2.337 2.337 0 012.33-2.33 2.337 2.337 0 012.33 2.33zm9.32-2.33a2.337 2.337 0 00-2.33 2.33 2.337 2.337 0 002.33 2.33 2.337 2.337 0 002.33-2.33 2.337 2.337 0 00-2.33-2.33zM7.486 15.612v-.117l1.049-1.98h8.62c.817 0 1.632-.466 1.982-1.165l4.543-8.156L21.7 3.03l-4.544 8.155H9L4.106.7H.262v2.33h2.33l4.194 8.854-1.631 2.797c-.117.35-.233.699-.233 1.165a2.337 2.337 0 002.33 2.33h13.98v-2.33H7.719a.25.25 0 01-.233-.233zm12.582-13.98L18.438 0l-5.593 5.592-3.029-3.029-1.631 1.631 4.66 4.66 7.223-7.223z","fill":"#fff"}})])
          )
        }
      }
    